export const ArrayHelper = {
  // 判斷兩個陣列是否相同(不考慮順序)
  shallowMatch(arr1: any[], arr2: any[]) {
    const sameSize = arr1.length === arr2.length;
    return sameSize && arr1.every((value) => arr2.includes(value));
  },
};
